import { useAppSelector } from 'client/hooks/useAppSelector';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ILoginFormValues } from '.';

export const useLoginForm = (onSubmit: SubmitHandler<ILoginFormValues>) => {
  const formMethods = useForm<ILoginFormValues>({ shouldFocusError: true });
  const { handleSubmit } = formMethods;
  const _onSubmit: SubmitHandler<ILoginFormValues> = (data) => {
    onSubmit(data);
  };
  // Sélectionner directement la propriété pour éviter les re-renders inutiles
  const loading = useAppSelector((state) => state.loading.loading);
  const [t] = useTranslation();

  return {
    formMethods,
    handleSubmit,
    _onSubmit,
    loading,
    t,
  };
};
